// extracted by mini-css-extract-plugin
export default {"map":"WsWYJ","mobile-map":"pkVpZ","mobileMap":"pkVpZ"};